import clsx from 'clsx'

import s from './Achievements.module.scss'
import type { AchievementItemProps, AchievementsProps } from './Achievements.props'

export function Achievements({ achievements, ...props }: AchievementsProps) {
  if (!achievements?.length) return null

  return (
    <ul className={s.list}>
      {achievements.map((achievement, index) => (
        <AchievementItem
          key={index}
          data={achievement}
          {...props}
        />
      ))}
    </ul>
  )
}

function AchievementItem({ data, iconWrapperClassName, itemClassName, reversed }: AchievementItemProps) {
  return (
    <li className={clsx(s.item, itemClassName, { [s.reversed]: reversed })}>
      <div className={s.wrapper}>
        {data?.title && <span className={s.title}>{data.title}</span>}
        <span className={s.text}>{data?.text}</span>
      </div>
      {data?.icon && (
        <div className={clsx(s.iconWrapper, iconWrapperClassName)}>
          <img
            src={data.icon}
            alt="Icon"
            width={24}
            height={24}
            className={s.icon}
          />
        </div>
      )}
    </li>
  )
}
